import { useState, type FormEvent } from 'react';
import Icon from '../components/Icon';
import './Pages.css';

interface FormData {
  name: string;
  email: string;
  org: string;
  role: string;
  message: string;
}

export default function Contact() {
  const [form, setForm] = useState<FormData>({ name: '', email: '', org: '', role: 'municipality', message: '' });
  const [sent, setSent] = useState(false);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 5000);
    setForm({ name: '', email: '', org: '', role: 'municipality', message: '' });
  };

  return (
    <div className="page">
      <section className="page-hero page-hero--dark">
        <div className="container">
          <span className="eyebrow">Get in touch</span>
          <h1>Let's build a resilient emergency layer for your community.</h1>
          <p className="lede">Municipalities, tourism operators, NGOs, and infrastructure projects, start a conversation about deploying SETU.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h3>Talk to the SETU team</h3>
              <p>
                Whether you're a rural municipality, a trekking operator along a remote route, or
                a humanitarian organization working in disaster response, we would like to hear from
                you.
              </p>
              <div className="contact-list">
                <div className="contact-item">
                  <div className="contact-item__icon"><Icon name="pin" size={18} /></div>
                  <div>
                    <strong>Location</strong>
                    <span>Kathmandu, Nepal</span>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item__icon"><Icon name="battery" size={18} /></div>
                  <div>
                    <strong>Email</strong>
                    <span>hello@setu.np</span>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item__icon"><Icon name="clock" size={18} /></div>
                  <div>
                    <strong>Response time</strong>
                    <span>Within 1 business day</span>
                  </div>
                </div>
              </div>
            </div>

            <form className="form" onSubmit={onSubmit}>
              <h3 style={{ marginBottom: 20 }}>Request a demo</h3>
              <div className="form__row">
                <div className="form__group">
                  <label htmlFor="name">Full name</label>
                  <input id="name" type="text" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
                </div>
                <div className="form__group">
                  <label htmlFor="email">Email</label>
                  <input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@org.com" />
                </div>
              </div>
              <div className="form__row">
                <div className="form__group">
                  <label htmlFor="org">Organization</label>
                  <input id="org" type="text" value={form.org} onChange={(e) => setForm({ ...form, org: e.target.value })} placeholder="Municipality, NGO, company…" />
                </div>
                <div className="form__group">
                  <label htmlFor="role">I represent a…</label>
                  <select id="role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
                    <option value="municipality">Municipality / local government</option>
                    <option value="tourism">Tourism / trekking operator</option>
                    <option value="ngo">NGO / humanitarian</option>
                    <option value="infra">Infrastructure project</option>
                    <option value="rescue">Search & rescue team</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form__group" style={{ marginBottom: 16 }}>
                <label htmlFor="message">Tell us about your context</label>
                <textarea id="message" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="What region are you interested in? How many devices might you need? Any timeline in mind?" />
              </div>
              <button type="submit" className="btn btn--primary btn--lg" style={{ width: '100%' }}>
                Send request
                <Icon name="arrow-right" size={18} className="arrow" />
              </button>
              {sent && (
                <div className="form__success">
                  ✓ Thanks! Your message has been received. We'll be in touch within 1 business day.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
